import {FC} from 'react';
import NavigationCard from './Card';
import {NAVIGATION_CARDS_CONFIG} from '../../../constants/dashboard';

const NavigationCards: FC = () => (
  <div className="navigation-cards">
    {NAVIGATION_CARDS_CONFIG.map((cardConfig) => (
      <NavigationCard cardConfig={cardConfig} key={cardConfig.path} />
    ))}
  </div>
);

export default NavigationCards;
